import * as React from 'react'

import { config } from '../../../../common/config'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import {
  activeFiltersParams,
  queryWithoutFilters
} from '../../../../common/utils/urlHelper'
import EmptyResultsPlaceholder from '../../../components/emptyResultsPlaceholder'
import DidYouMeanBy from '../../../components/searchResultHeaders/didYouMeanBy'
import SearchLink from '../../../containers/searchLinkContainer'

import * as didYouMeanLinkStyles from './didYouMeanLink.module.css'
import * as styles from './searchNoResults.module.css'

interface IProps {
  locationParams: ILocationParams
  didYouMeanByTerms: string[]
}

const SearchNoResults: React.StatelessComponent<IProps> = props => {
  const renderClearFiltersLink = () => {
    const link = (
      <SearchLink
        locationParams={queryWithoutFilters(locationParams)}
        className={styles.clearFilterLink}
      >
        clearing some filters
      </SearchLink>
    )

    return <span>Try {link} and try again.</span>
  }

  const { locationParams, didYouMeanByTerms } = props
  const hasActiveFilters = activeFiltersParams(locationParams).length

  const renderHeading = () => (
    <React.Fragment>
      {hasActiveFilters || didYouMeanByTerms.length === 0 ? (
        'Nothing exists here'
      ) : (
        <DidYouMeanBy {...props} styles={didYouMeanLinkStyles} />
      )}
    </React.Fragment>
  )

  const renderSubHeading = () => (
    <React.Fragment>
      {"We couldn't find any results for your search. "}
      {hasActiveFilters
        ? renderClearFiltersLink()
        : 'Use more generic words or double check your spelling.'}
    </React.Fragment>
  )

  return (
    <EmptyResultsPlaceholder
      heading={renderHeading()}
      subHeading={renderSubHeading()}
    />
  )
}

export default SearchNoResults
